export const formatNumber = (
  value: string,
  pattern: string = '#### ### ####'
) => {
  const phone = value.replace(/\s+/g, '').split('');
  let i = -1;

  return pattern.replace(/#/g, (_) => {
    i++;
    return phone[i] === undefined ? '' : phone[i];
  });
};
